var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 5.83333C11.6666 8.74592 8.43556 11.7793 7.35056 12.7161C7.24949 12.7921 7.12645 12.8332 6.99998 12.8332C6.87351 12.8332 6.75047 12.7921 6.6494 12.7161C5.5644 11.7793 2.33331 8.74592 2.33331 5.83333C2.33331 4.59566 2.82498 3.40867 3.70015 2.5335C4.57532 1.65833 5.7623 1.16667 6.99998 1.16667C8.23766 1.16667 9.42464 1.65833 10.2998 2.5335C11.175 3.40867 11.6666 4.59566 11.6666 5.83333Z",
    stroke: "#009075",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.58333C7.9665 7.58333 8.75 6.79983 8.75 5.83333C8.75 4.86683 7.9665 4.08333 7 4.08333C6.0335 4.08333 5.25 4.86683 5.25 5.83333C5.25 6.79983 6.0335 7.58333 7 7.58333Z",
    stroke: "#009075",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.c6f9773eaf172ed8f090fad09d107d8c.svg";
export { ForwardRef as ReactComponent };